
import { computed, defineComponent, ref, watch } from 'vue'
import { mq, isLoadingEndpoint } from 'mega-composable'
import { find, findIndex } from 'lodash-es'
import { steps } from '@/store/case'
import { Step } from '@/types/api/steps'
import { trackCheckProgress } from '@/core/services/tracking-service'

export default defineComponent({
  setup() {
    const isExpanded = ref(false)
    const isVerticalStepper = computed(() => mq.value.toLarge)
    const currentStepNumber = computed(() => findIndex(steps.value, (item: Step) => item.status === 'current') + 1)
    const currentStepTitle = computed(() => find(steps.value, (item: Step) => item.status === 'current')?.title)
    const currentStepDescription = computed(() => find(steps.value, (item: Step) => item.status === 'current')?.description)
    const countSteps = computed(() => steps.value?.length)
    const countFinishedSteps = computed(() => steps.value?.filter((item: Step) => item.status === 'completed').length || 0)
    const expandButtonText = computed(() => `${currentStepTitle.value} (${countFinishedSteps.value + 1}/${countSteps.value})`)

    const isLastStep = (index: number) => steps.value && index === steps.value.length - 1
    const isInactive = (step: Step) => step.status === 'upcoming'
    const isCompleted = (step: Step) => step.status === 'completed'
    const isCurrent = (step: Step) => step.status === 'current'
    const showStepDescription = (step: Step) => isVerticalStepper.value && step.status === 'current' && step.description
    const hiddenDividerClass = (step: Step) => !isCurrent(step) && isVerticalStepper.value ? 'divider--finished-vertical' : ''

    const isLoading = isLoadingEndpoint('request/steps')

    watch(isExpanded, (value) => {
      if (value) {
        trackCheckProgress()
      }
    })

    return {
      isExpanded,
      expandButtonText,
      isLastStep,
      isInactive,
      isCompleted,
      isCurrent,
      isVerticalStepper,
      currentStepNumber,
      currentStepTitle,
      currentStepDescription,
      showStepDescription,
      hiddenDividerClass,
      steps,
      isLoading
    }
  }
})
